import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { TransportistaSatisfaccionGatewayApi } from 'src/core/apis/satisfaccion';
import { TransportistaSatisfaccionSetGatewayApi } from 'src/core/apis/satisfaccion.set';
import { legacySaveEncuestaDataToSatisfaccionMxBody } from 'src/app/services/pedidos/gateway-satisfaccion.mapper';

/** Encuesta de satisfacción desactivada en toda la aplicación. */
export const ENCUESTA_SATISFACCION_ENABLED = false;

@Injectable({
  providedIn: 'root',
})
export class EncuestaService {
  constructor(
    private readonly satisfaccionGateway: TransportistaSatisfaccionGatewayApi,
    private readonly satisfaccionSetGateway: TransportistaSatisfaccionSetGatewayApi
  ) {}

  SaveEncuesta(data) {
    if (!ENCUESTA_SATISFACCION_ENABLED) {
      return of(null);
    }

    const body = legacySaveEncuestaDataToSatisfaccionMxBody(
      data as Record<string, unknown>
    );
    return this.satisfaccionSetGateway.post(body).pipe(timeout(200000));
  }

  saveSurveyMixer(data) {
    if (!ENCUESTA_SATISFACCION_ENABLED) {
      return of(null);
    }

    const body = {
      puntos: data['puntos'],
    };
    return this.satisfaccionGateway.post(body).pipe(timeout(200000));
  }
}
